var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 7.99999H12.865L9.232 12.36C8.878 12.784 8.936 13.415 9.36 13.768C9.785 14.122 10.415 14.064 10.769 13.64L15.769 7.63999C15.808 7.59299 15.827 7.53799 15.856 7.48599C15.88 7.44399 15.909 7.40799 15.927 7.36199C15.972 7.24699 15.999 7.12599 15.999 7.00399C15.999 7.00299 16 7.00099 16 6.99999C16 6.99899 15.999 6.99699 15.999 6.99599C15.999 6.87399 15.972 6.75299 15.927 6.63799C15.909 6.59199 15.88 6.55599 15.856 6.51399C15.827 6.46199 15.808 6.40699 15.769 6.35999L10.769 0.359985C10.57 0.122985 10.286 -1.52588e-05 10 -1.52588e-05C9.774 -1.52588e-05 9.547 0.0759847 9.36 0.231985C8.936 0.584985 8.878 1.21598 9.232 1.63998L12.865 5.99999H1C0.448 5.99999 0 6.44799 0 6.99999C0 7.55199 0.448 7.99999 1 7.99999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/ArrowRightWhite.af1a350f22b2de135dc53dd5555b5f51.svg";
export { ForwardRef as ReactComponent };